export const MAINTENANCE_SYSTEMS = [

  {
    value: "engine",
    label: "Motor"
  },

  {
    value: "transmission",
    label: "Transmisión"
  },

  {
    value: "brakes",
    label: "Frenos"
  },

  {
    value: "suspension",
    label: "Suspensión"
  },

  {
    value: "steering",
    label: "Dirección"
  },

  {
    value: "tires",
    label: "Llantas"
  },

  {
    value: "electrical",
    label: "Sistema eléctrico"
  },

  {
    value: "cooling",
    label: "Sistema de enfriamiento"
  },

  {
    value: "air_conditioning",
    label: "Aire acondicionado"
  },

  {
    value: "bodywork",
    label: "Carrocería"
  },

  {
    value: "cleaning",
    label: "Limpieza"
  },

  {
    value: "other",
    label: "Otro"
  }

];